// Hardcoded for now, but may need to be flatmaped from navigation.ts in the future
export const accountUrls = [
  '/errorpage.aspx',
  '/homepage.aspx',
  '/error_nojavascript.aspx',
  '/myproviders.aspx',
  '/removeproviders.aspx',
  '/addprimary.aspx',
  '/removeprimary.aspx',
  '/addprovidermanually.aspx',
  '/messagedetail.aspx',
  '/deletedmessages.aspx',
  '/deletedmessagedetail.aspx',
  '/mypreventiveservices.aspx',
  '/plansandcoverage.aspx',
  '/plansandcoveragedrugcard.aspx',
  '/enrollmentconfirmation.aspx',
  '/claims.aspx',
  '/recentclaims.aspx',
  '/searchclaims.aspx',
  '/claimsearchresult.aspx',
  '/medicareadvantageclaims.aspx',
  '/dashboard.aspx',
  '/myhealth.aspx',
  '/basichealthinfo.aspx',
  '/editbasichealthinfo.aspx',
  '/editemergencycontacts.aspx',
  '/emergencycontacts.aspx',
  '/familymedicalhistory.aspx',
  '/editfamilymedicalhistory.aspx',
  '/allergies.aspx',
  '/addeditallergies.aspx',
  '/immunizations.aspx',
  '/addeditimmunizations.aspx',
  '/labsandtests.aspx',
  '/addeditlabsandtests.aspx',
  '/vitalstatistics.aspx',
  '/addeditvitalstatistics.aspx',
  '/medicalconditions.aspx',
  '/addeditmedicalconditions.aspx',
  '/implantabledevices.aspx',
  '/addeditimplantabledevices.aspx',
  '/selfreportedhealthinformation.aspx',
  '/mydrugs.aspx',
  '/mypharmacy.aspx',
  '/onthegoreport.aspx',
  '/downloadmydata.aspx',
  '/downloadinformation.aspx',
  '/viewmsn.aspx',
  '/claimdetails.aspx',
  '/ordermsn.aspx',
  '/claimdeductible.aspx',
  '/myaccount.aspx',
  '/authorizedrep.aspx',
  '/orderhistory.aspx',
  '/editemail.aspx',
  '/editcommunicationsettings.aspx',
  '/accountsettings.aspx',
  '/deactivate.aspx',
  '/editusername.aspx',
  '/editpassword.aspx',
  '/editsecretqa.aspx',
  '/deactivatesuccess.aspx',
  '/ordermedicarecard.aspx',
  '/providersandservices.aspx',
  '/drugsandpharmacies.aspx',
  '/emsn.aspx',
  '/ieqprint.aspx',
  '/ieqdisabled.aspx',
  '/createonthegoreport.aspx',
  '/onthegoreportdownload.aspx',
  '/mspdetails.aspx',
  '/mspprint.aspx',
  '/mspdisclaimer.aspx',
  '/mspsummary.aspx',
  '/msadisclaimer.aspx',
  '/msasummary.aspx',
  '/myemailcorrection.aspx',
  '/viewpdfmsn.aspx',
  '/msp_error.aspx',
  '/authmedicarecard.aspx',
  '/medicarecard.aspx',
  '/accountlocked.aspx',
  '/premiumpayment.aspx',
  '/premiumpaycancel.aspx',
  '/premiumpayreview.aspx',
  '/premiumpaycomplete.aspx',
  '/premiumpayfailure.aspx',
  '/premiumpaymenthistory.aspx',
  '/premiumbillsummary.aspx',
  '/premiuminformation.aspx',
  '/monthlypremium.aspx',
  '/easypaysignup.aspx',
  '/easypaysignupreview.aspx',
  '/easypaysignupcomplete.aspx',
  '/easypaychange.aspx',
  '/easypaychangecomplete.aspx',
  '/easypaystopreview.aspx',
  '/easypaystopcomplete.aspx',
  '/connectedapps.aspx',
  '/revokeappaccess.aspx',
  '/revokeappconfirmation.aspx'
]

export const messageUrls = [
  '/mymessages.aspx?lang=es-mx',
  '/mymessages.aspx'
]
